export const SERVER_URL = 'https://dev.admin.leaf-wellness.org/api/v1';
